/**
 * master
 *  ## 공통으로 사용되는 데이터를 등록,조회,수정,삭제한다. 
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs/Observable';

import { Failure } from '../model/failure';
import { Holidays } from '../model/holidays';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class HolidayService {

    protected basePath = 'http://bstore-dev-nlb-to-backends-03c7de26a0c53e22.elb.ap-northeast-2.amazonaws.com:9900/master/v1';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 공휴일 전체 조회
     * 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public holidayGet(observe?: 'body', reportProgress?: boolean): Observable<Array<Holidays>>;
    public holidayGet(observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Holidays>>>;
    public holidayGet(observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Holidays>>>;
    public holidayGet(observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<Holidays>>(`${this.basePath}/holiday`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 특정 공휴일 정보 삭제
     * 
     * @param holiday_id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public holidayHolidayIdDelete(holiday_id: string, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public holidayHolidayIdDelete(holiday_id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public holidayHolidayIdDelete(holiday_id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public holidayHolidayIdDelete(holiday_id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (holiday_id === null || holiday_id === undefined) {
            throw new Error('Required parameter holiday_id was null or undefined when calling holidayHolidayIdDelete.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];

        return this.httpClient.delete<any>(`${this.basePath}/holiday/${encodeURIComponent(String(holiday_id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 공공데이터 포탈사이트에서 공휴일 조회 후 법정공휴일 등록
     * 
     * @param holiday_year 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public holidayPortalHolidayYearGet(holiday_year: string, observe?: 'body', reportProgress?: boolean): Observable<Holidays>;
    public holidayPortalHolidayYearGet(holiday_year: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Holidays>>;
    public holidayPortalHolidayYearGet(holiday_year: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Holidays>>;
    public holidayPortalHolidayYearGet(holiday_year: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (holiday_year === null || holiday_year === undefined) {
            throw new Error('Required parameter holiday_year was null or undefined when calling holidayPortalHolidayYearGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Holidays>(`${this.basePath}/holiday/portal/${encodeURIComponent(String(holiday_year))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 공휴일 등록
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public holidayPost(body: Holidays, observe?: 'body', reportProgress?: boolean): Observable<any>;
    public holidayPost(body: Holidays, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<any>>;
    public holidayPost(body: Holidays, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<any>>;
    public holidayPost(body: Holidays, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling holidayPost.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post<any>(`${this.basePath}/holiday`,
            body,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 특정 공휴일 조회 - 해당년으로 조회
     * 
     * @param holiday_year 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public holidaySaerchHolidayYearGet(holiday_year: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Holidays>>;
    public holidaySaerchHolidayYearGet(holiday_year: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Holidays>>>;
    public holidaySaerchHolidayYearGet(holiday_year: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Holidays>>>;
    public holidaySaerchHolidayYearGet(holiday_year: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (holiday_year === null || holiday_year === undefined) {
            throw new Error('Required parameter holiday_year was null or undefined when calling holidaySaerchHolidayYearGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<Holidays>>(`${this.basePath}/holiday/saerch/${encodeURIComponent(String(holiday_year))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 특정 공휴일 조회 - 해당년월로 조회
     * 
     * @param holiday_year 
     * @param holiday_month 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public holidaySpecificHolidayYearHolidayMonthGet(holiday_year: string, holiday_month: string, observe?: 'body', reportProgress?: boolean): Observable<Array<Holidays>>;
    public holidaySpecificHolidayYearHolidayMonthGet(holiday_year: string, holiday_month: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<Holidays>>>;
    public holidaySpecificHolidayYearHolidayMonthGet(holiday_year: string, holiday_month: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<Holidays>>>;
    public holidaySpecificHolidayYearHolidayMonthGet(holiday_year: string, holiday_month: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {
        if (holiday_year === null || holiday_year === undefined) {
            throw new Error('Required parameter holiday_year was null or undefined when calling holidaySpecificHolidayYearHolidayMonthGet.');
        }
        if (holiday_month === null || holiday_month === undefined) {
            throw new Error('Required parameter holiday_month was null or undefined when calling holidaySpecificHolidayYearHolidayMonthGet.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<Holidays>>(`${this.basePath}/holiday/specific/${encodeURIComponent(String(holiday_year))}/${encodeURIComponent(String(holiday_month))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
